import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import ICONS from "../../../../../assets/Icons";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";

const BeneficiaryMultiApprovalSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [approvedTransactions, setApprovedTransactions] = useState([]);
  const [pendingTransactions, setPendingTransactions] = useState([]);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    const storedData = JSON.parse(sessionStorage.getItem("selectedData"));

    if (storedData?.selectedSendTransactions?.length) {
      const transactions = storedData.selectedSendTransactions;

      setApprovedTransactions(
        transactions.filter((txn) => txn.lifecycle_status === "approved"),
      );

      setPendingTransactions(
        transactions.filter((txn) => txn.lifecycle_status === "pending"),
      );
    }
  }, []);

  const buttonRows = [
    [
      {
        btnText: "Approve more transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.ADD_BUTTON,
        imgColor: "var(--positive-bg)",
        handleFunction: () =>
          navigate(
            "/beneficiary_transaction_dashboard/beneficiary_transaction_multi_approval",
          ),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => navigate("/beneficiary_transaction_dashboard"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const TransactionList = ({ transactions }) => (
    <>
      {transactions?.map((txn, i) => (
        <InfoCard
          key={i}
          bgColor="var(--positive-card)"
          hoverable="white"
          onClick={() =>
            navigate(
              `/beneficiary_transaction_dashboard/beneficiary_transaction_view_all/beneficiary_transaction_detail_page/${txn?.txn_id}`,
            )
          }
          rows={[
            {
              leftTitle: txn?.beneficiary_account_name
                ?.toLowerCase()
                .split(" ")
                .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                .join(" "),
              leftSubTitle: "Beneficiary name",
              rightText: true,
              rightIcon: false,
              rightTitle: `INR ${FormatAmount({ price: txn?.amount })}`,
              rightSubTitle: "Amount",
              rightTitleTextColor: "var(--text-primary)",
              rightTextFontWeight: "semibold",
            },
          ]}
        />
      ))}
    </>
  );

  const totalTransactions =
    approvedTransactions.length + pendingTransactions.length;

  let titleText = "";

  if (!approvedTransactions.length && pendingTransactions.length) {
    titleText =
      totalTransactions === 1
        ? "Transactions has been approved and pending further approval before distribution."
        : "Transactions have been approved and pending further approval before distribution.";
  } else {
    titleText =
      totalTransactions === 1
        ? "Transactions has been approved."
        : "Transactions have been approved.";
  }

  return (
    <StatusContainer
      status="success"
      title={titleText}
      buttonRows={buttonRows}
    >
      {!!(pendingTransactions.length && !approvedTransactions.length) && (
        <TabsWeapperSection title={`Pending - ${pendingTransactions.length} `}>
          <TransactionList transactions={pendingTransactions} />
        </TabsWeapperSection>
      )}

      {!!(approvedTransactions.length && !pendingTransactions.length) && (
        <TabsWeapperSection
          title={`Distribution created - ${approvedTransactions.length} `}
        >
          <TransactionList transactions={approvedTransactions} />
        </TabsWeapperSection>
      )}

      {!!(approvedTransactions.length && pendingTransactions.length) && (
        <>
          <TabsWeapperSection
            title={`Distribution created - ${approvedTransactions.length}`}
          >
            <TransactionList transactions={approvedTransactions} />
          </TabsWeapperSection>

          <TabsWeapperSection title={`Pending - ${pendingTransactions.length}`}>
            <TransactionList transactions={pendingTransactions} />
          </TabsWeapperSection>
        </>
      )}
    </StatusContainer>
  );
};

export default BeneficiaryMultiApprovalSuccess;
